import PageHeader from "Components/Pages/Header";
import { useState } from "react";
import Input from "Components/Form/Input";
import Select from "Components/Form/Select";
import { getResultStatus } from "Requests/Result";
import { createToast } from "Utils/toastFunc";
import { Button } from "Components/Button";
import {
  ContainerForm,
  MainContent,
  PageContainer,
  PageContent,
} from "./styles";
import { Result as ResultTS, ResultStatus } from "./components/ResultStatus";

const OPTIONS = [
  { value: "requisition_code", label: "Código de requisição" },
  { value: "name", label: "Nome" },
  { value: "cpf", label: "CPF" },
  { value: "email", label: "E-mail" },
];

export const Result = () => {
  const [search, setSearch] = useState("");
  const [type, setType] = useState("");
  const [data, setData] = useState<ResultTS[] | null>(null);
  const [error, setErros] = useState("");
  const [loading, setLoading] = useState(false);
  const handleChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const handleChangeType = (e: React.ChangeEvent<HTMLInputElement>) => {
    setType(e.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleSearch = async () => {
    try {
      setLoading(true);
      const search_query = OPTIONS.find((option) => option.label === type);

      if (!search_query) return;

      const response = await getResultStatus(`${search_query.value}=${search}`);

      setData(response.reports);
    } catch (error: any) {
      const errorMessage = error.response.data.message;
      setErros(errorMessage);
      setData(null);

      createToast("error", errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageContainer className="entry-app-content entry-budget">
      <PageContent>
        <div className="page-heading">
          <div className="wrapper-header-content">
            <PageHeader title="Consulta de status de resultado e envio ao parceiro">
              <p />
            </PageHeader>
          </div>
        </div>
      </PageContent>

      <MainContent>
        <div className="wrapper-form">
          <div className={`search-wrapper  `}>
            <h2 className="text-center text-centered text-purple section-title">
              Busque pelo status do resultado
            </h2>

            <ContainerForm className="search-bar">
              <Select
                label=""
                id="type"
                placeholder="Tipo de busca"
                optionName="label"
                options={OPTIONS}
                value={type}
                onChange={handleChangeType}
              />

              <Input
                label=""
                id="cep"
                value={search}
                type="text"
                error={false}
                required={false}
                purple={false}
                multiline={false}
                onChange={handleChangeSearch}
                onFocus={() => {}}
                onBlur={() => {}}
                placeholder="Buscar..."
                description=""
                mask=""
                maskChar=""
                maxLength=""
                min=""
                readOnly={!type}
                small={false}
                onKeyPress={handleKeyDown}
              />
              <Button
                type="submit"
                loading={loading}
                classButton="button button-search"
                onClick={handleSearch}
              >
                <i className="icon-loupe" />
              </Button>
            </ContainerForm>

            <div className="schedule-sec" />
          </div>
        </div>

        {!data && error && <p className="result-error">{error}</p>}

        {data && <ResultStatus data={data} />}
      </MainContent>
    </PageContainer>
  );
};
